module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/timeline_3-b47b7ce4ef0aac8257b8f1294ce0da04.svg";